<template>
  <div style="padding: 3px">
    <div class="card" style="margin-bottom: 10px">
      <div class="card-body" style="background-color: transparent">
        <!-- Move PERÍODO DE VENTAS section to the top -->
        <div class="row mb-4">
          <div class="col-12">
            <p class="title" style="margin-bottom: 0">SELECCIÓN DE PERÍODO</p>
            <div class="dateContainer">
              <div class="date-input">
                <label class="labelText" for="desde">Desde:</label>
                <input
                  class="form-control"
                  type="date"
                  id="from"
                  v-model="from"
                  :max="to"
                  @change="validateDates"
                />
              </div>
              <div class="date-input">
                <label class="labelText" for="to">Hasta:</label>
                <input
                  class="form-control"
                  type="date"
                  id="to"
                  v-model="to"
                  :min="from"
                  @change="validateDates"
                />
              </div>
              <div>
                <button
                  class="btn btn-primary"
                  @click="getSummary"
                  :disabled="!datesValid"
                >
                  Obtener Reporte
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Resumen Column -->
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 mb-3">
            <!-- Resumen de Cantidades -->
            <div>
              <h5 class="title">Resumen Histórico</h5>
              <div class="stats-container">
                <div class="stat-item">
                  <span class="stat-label">Total de usuarios:</span>
                  <span class="stat-value">{{ totalUsers() }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Total de Leads:</span>
                  <span class="stat-value">{{ countSales() }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Total de Ventas Instaladas:</span>
                  <span class="stat-value">{{ countInstalledSales() }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Total de Ventas En Gestión:</span>
                  <span class="stat-value">{{ countPendingSales() }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Total de Cierres Perdidos:</span>
                  <span class="stat-value">{{
                    countNotPendingNotInstalledSales()
                  }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Porcentaje de Conversión:</span>
                  <span class="stat-value"
                    >{{
                      ((countInstalledSales() / countSales()) * 100).toFixed(2)
                    }}%</span
                  >
                </div>
                <div class="stat-item">
                  <span class="stat-label">Comisiones por pagar:</span>
                  <span class="stat-value">${{ totalBalance.toFixed(2) }}</span>
                </div>
              </div>
            </div>

            <!-- Deal Closing Time Statistics -->
            <div class="mt-4">
              <h5 class="title">Estadísticas de Tiempo de Cierre</h5>
              <div class="stats-container">
                <div class="stat-item">
                  <span class="stat-label">Total de Ventas Analizadas:</span>
                  <span class="stat-value">{{
                    dealClosingStats.totalSales
                  }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Tiempo Promedio de Cierre:</span>
                  <span class="stat-value">
                    {{ formatClosingTime(dealClosingStats.averageClosingTime) }}
                  </span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Tiempo Mediano de Cierre:</span>
                  <span class="stat-value">
                    {{ formatClosingTime(dealClosingStats.medianClosingTime) }}
                  </span>
                </div>
                <!-- <div class="stat-item">
                  <span class="stat-label">Venta Más Rápida:</span>
                  <span class="stat-value">
                    {{
                      formatClosingTime(
                        dealClosingStats.fastestSale.closingTime,
                      )
                    }}
                  </span>
                  <small class="stat-detail">
                    {{ formatSaleInfo(dealClosingStats.fastestSale) }}
                  </small>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Venta Más Lenta:</span>
                  <span class="stat-value">
                    {{
                      formatClosingTime(
                        dealClosingStats.slowestSale.closingTime,
                      )
                    }}
                  </span>
                  <small class="stat-detail">
                    {{ formatSaleInfo(dealClosingStats.slowestSale) }}
                  </small>
                </div> -->
              </div>
            </div>
          </div>

          <!-- Charts Column -->
          <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
            <!-- First Chart - Column Chart -->
            <div class="card shadow-lg p-4 mb-4">
              <h5 class="title">Usuarios Nuevos por Fecha y Ciudad</h5>
              <p class="text-muted mb-3">
                Muestra la cantidad de usuarios registrados por día y su
                distribución por ciudad (top 5 ciudades) en el periodo
                seleccionado
              </p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="total-summary">
                  <span class="fw-bold">Total de usuarios en el periodo: </span>
                  <span class="total-value">{{
                    data.length > 1
                      ? data.slice(1).reduce((sum, row) => {
                          // Sum all values except the first column (date)
                          const rowSum = row
                            .slice(1)
                            .reduce(
                              (rowTotal, value) =>
                                rowTotal + (Number(value) || 0),
                              0,
                            );
                          return sum + rowSum;
                        }, 0)
                      : 0
                  }}</span>
                </div>
              </div>
              <GChart
                type="ColumnChart"
                :resizeDebounce="500"
                :options="options"
                :data="data"
              />
            </div>

            <!-- City Chart - Column Chart -->
            <div class="card shadow-lg p-4 mb-4">
              <h5 class="title">Top 10 Ciudades por Usuarios</h5>
              <p class="text-muted mb-3">
                Muestra las 10 ciudades con mayor cantidad de usuarios
                registrados en el periodo seleccionado
              </p>
              <div
                class="d-flex justify-content-between align-items-center mb-3"
              >
                <div class="total-summary">
                  <span class="fw-bold">Ciudades mostradas: </span>
                  <span class="total-value">{{
                    cityChartData.length > 1 ? cityChartData.length - 1 : 0
                  }}</span>
                </div>
                <div class="total-summary">
                  <span class="fw-bold"
                    >Total de usuarios en top ciudades:
                  </span>
                  <span class="total-value">{{
                    cityChartData.length > 1
                      ? cityChartData
                          .slice(1)
                          .reduce((sum, row) => sum + (Number(row[1]) || 0), 0)
                      : 0
                  }}</span>
                </div>
              </div>
              <GChart
                type="ColumnChart"
                :resizeDebounce="500"
                :options="cityChartOptions"
                :data="cityChartData"
              />
            </div>

            <!-- Second Chart - Area Chart -->
            <div class="card shadow-lg p-4 mb-4">
              <h5 class="title">Tendencia de Ventas por Día</h5>
              <p class="text-muted mb-3">
                Muestra la tendencia de ventas instaladas y otras ventas por día
              </p>
              <GChart
                type="AreaChart"
                :resizeDebounce="500"
                :options="areaChartOptions"
                :data="areaChartData"
              />
            </div>

            <!-- Third Chart - Bar Chart -->
            <div class="card shadow-lg p-4 mb-4">
              <h5 class="title">Distribución de Ventas por Categoría</h5>
              <p class="text-muted mb-3">
                Muestra la distribución de ventas por categoría en el periodo
                seleccionado
              </p>
              <div class="row">
                <div class="col-md-8">
                  <GChart
                    type="ColumnChart"
                    :resizeDebounce="500"
                    :options="barChartOptions"
                    :data="barChartData"
                  />
                </div>
                <div class="col-md-4">
                  <div class="stats-summary">
                    <div class="summary-item">
                      <div class="summary-label">
                        Total de Leads en Periodo:
                      </div>
                      <div class="summary-value">{{ totalPeriodSales }}</div>
                    </div>
                    <div class="summary-item">
                      <div class="summary-label">Ventas Instaladas:</div>
                      <div class="summary-value">
                        {{ totalInstalledSales }} ({{ installedPercentage }}%)
                      </div>
                    </div>
                    <div class="summary-item">
                      <div class="summary-label">Ventas Pendientes:</div>
                      <div class="summary-value">
                        {{ totalPendingSales }} ({{ pendingPercentage }}%)
                      </div>
                    </div>
                    <div class="summary-item">
                      <div class="summary-label">Sin Cobertura:</div>
                      <div class="summary-value">
                        {{ totalNoCoverageSales }} ({{ noCoveragePercentage }}%)
                      </div>
                    </div>
                    <div class="summary-item">
                      <div class="summary-label">No Desea/No Contesta:</div>
                      <div class="summary-value">
                        {{ totalNotInterestedSales }} ({{
                          notInterestedPercentage
                        }}%)
                      </div>
                    </div>
                    <div class="summary-item">
                      <div class="summary-label">En Negociación:</div>
                      <div class="summary-value">
                        {{ totalInNegotiationSales }} ({{
                          inNegotiationPercentage
                        }}%)
                      </div>
                    </div>
                    <div class="summary-item">
                      <div class="summary-label">Promedio Diario:</div>
                      <div class="summary-value">{{ averageDailySales }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sales Map -->
            <!-- <div class="card shadow-lg p-4 mb-4">
              <h5 class="title">
                <i class="fas fa-map-marker-alt"></i>
                Mapa de Ubicaciones de Ventas Instaladas
              </h5>
              <p class="text-muted mb-3">
                Muestra la ubicación geográfica de todas las ventas instaladas
                con información de tiempo de cierre
              </p>
              <div class="map-stats mb-3">
                <div class="row">
                  <div class="col-md-3 col-sm-6 mb-2">
                    <div class="map-stat-card">
                      <div class="stat-number">
                        {{ salesWithCoordinates.length }}
                      </div>
                      <div class="stat-label">Ventas con Ubicación</div>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 mb-2">
                    <div class="map-stat-card">
                      <div class="stat-number">
                        {{ salesWithoutCoordinates.length }}
                      </div>
                      <div class="stat-label">Sin Ubicación</div>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 mb-2">
                    <div class="map-stat-card">
                      <div class="stat-number">{{ averageClosingDays }}</div>
                      <div class="stat-label">Promedio Días Cierre</div>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 mb-2">
                    <div class="map-stat-card">
                      <div class="stat-number">{{ uniqueCities.length }}</div>
                      <div class="stat-label">Ciudades</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="map-legend mb-3">
                <h6 class="legend-title">Leyenda de Tiempo de Cierre:</h6>
                <div class="legend-items">
                  <div class="legend-item">
                    <div
                      class="legend-color"
                      style="background-color: #28a745"
                    ></div>
                    <span>0-7 días (Rápido)</span>
                  </div>
                  <div class="legend-item">
                    <div
                      class="legend-color"
                      style="background-color: #fd7e14"
                    ></div>
                    <span>8-14 días (Moderado)</span>
                  </div>
                  <div class="legend-item">
                    <div
                      class="legend-color"
                      style="background-color: #ffc107"
                    ></div>
                    <span>15-30 días (Lento)</span>
                  </div>
                  <div class="legend-item">
                    <div
                      class="legend-color"
                      style="background-color: #dc3545"
                    ></div>
                    <span>+30 días (Muy Lento)</span>
                  </div>
                </div>
              </div>
              <div class="map-container">
                <l-map
                  v-if="salesWithCoordinates.length > 0"
                  ref="map"
                  :zoom="mapZoom"
                  :center="mapCenter"
                  :options="mapOptions"
                  style="height: 500px; width: 100%"
                  @ready="onMapReady"
                >
                  <l-tile-layer
                    :url="tileLayerUrl"
                    :attribution="tileLayerAttribution"
                  ></l-tile-layer>

                  <l-marker
                    v-for="sale in salesWithCoordinates"
                    :key="sale.saleId"
                    :lat-lng="[sale.latitude, sale.longitude]"
                    :icon="getMarkerIcon(sale)"
                  >
                    <l-popup>
                      <div class="popup-content">
                        <h6 class="popup-title">{{ sale.referrerFullName }}</h6>
                        <div class="popup-details">
                          <p><strong>ID Venta:</strong> {{ sale.saleId }}</p>
                          <p>
                            <strong>Ubicación:</strong>
                            {{ sale.location || "No especificada" }}
                          </p>
                          <p>
                            <strong>Tiempo de Cierre:</strong>
                            {{ sale.timeDiffDays }} días
                          </p>
                          <p>
                            <strong>Fecha Creación:</strong>
                            {{ formatDate(sale.createdAt) }}
                          </p>
                          <p>
                            <strong>Fecha Instalación:</strong>
                            {{ formatDate(sale.updatedOn) }}
                          </p>
                        </div>
                      </div>
                    </l-popup>
                  </l-marker>
                </l-map>
                <div v-else class="map-empty">
                  <i class="fas fa-map-marker-alt fa-3x text-muted"></i>
                  <p class="mt-3 text-muted">
                    No hay ventas con coordenadas disponibles para mostrar en el
                    mapa
                  </p>
                </div>
              </div>
            </div> -->
          </div>
        </div>

        <!-- Top Rankings Section -->
        <div class="row mt-5">
          <div class="col-md-6 mb-4">
            <div class="ranking-card">
              <h6 class="ranking-title">
                <i class="fas fa-medal"></i>
                Top 10 Vendedores
              </h6>
              <div class="ranking-list">
                <div
                  v-for="(seller, index) in topTenSellersWithNames"
                  :key="seller.userId"
                  class="ranking-item"
                >
                  <span class="ranking-position">#{{ index + 1 + " " }}</span>
                  <span class="ranking-name">
                    {{ seller.names }} {{ seller.lastnames }}
                  </span>
                  <span class="ranking-value">{{ seller.sales }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="ranking-card">
              <h6 class="ranking-title">
                <i class="fas fa-trophy"></i>
                Top 10 Balances
              </h6>
              <div class="ranking-list">
                <div
                  v-for="(balance, index) in topTenBalancesWithNames"
                  :key="balance.userId"
                  class="ranking-item"
                >
                  <span class="ranking-position">#{{ index + 1 }}</span>
                  <span class="ranking-name">
                    {{ balance.names }} {{ balance.lastnames }}
                  </span>
                  <span class="ranking-value"
                    >${{ balance.balanceTotal.toFixed(2) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Users by Province Section -->
        <div class="row mt-5">
          <!-- <div class="col-12">
            <h5 class="title">
              <i class="fas fa-map-marker-alt"></i>
              Distribución por Provincias de Ecuador
            </h5>

            <div class="row mb-4">
              <div class="col-md-3 col-sm-6 mb-3">
                <div class="province-summary-card">
                  <div class="summary-number">
                    {{ Object.keys(usersByProvince).length }}
                  </div>
                  <div class="summary-label">Provincias con Usuarios</div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 mb-3">
                <div class="province-summary-card">
                  <div class="summary-number">{{ totalUsers() }}</div>
                  <div class="summary-label">Total de Usuarios</div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 mb-3">
                <div class="province-summary-card">
                  <div class="summary-number">{{ getTopProvince().count }}</div>
                  <div class="summary-label">{{ getTopProvince().name }}</div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 mb-3">
                <div class="province-summary-card">
                  <div class="summary-number">
                    {{
                      Math.round((getTopProvince().count / totalUsers()) * 100)
                    }}%
                  </div>
                  <div class="summary-label">Concentración Máxima</div>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Buscar provincia..."
                  v-model="provinceSearchTerm"
                />
              </div>
              <div class="col-md-6">
                <select class="form-control" v-model="provinceSortOrder">
                  <option value="count-desc">Mayor cantidad primero</option>
                  <option value="alphabetical">Orden alfabético</option>
                  <option value="count-asc">Menor cantidad primero</option>
                </select>
              </div>
            </div>

            <div class="provinces-grid">
              <div
                v-for="(province, index) in filteredAndSortedProvinces"
                :key="province.name"
                class="province-card"
              >
                <div class="province-header">
                  <div class="province-info">
                    <span
                      class="province-rank"
                      v-if="provinceSortOrder === 'count-desc'"
                    >
                      #{{ index + 1 }}
                    </span>
                    <h6 class="province-name">{{ province.name }}</h6>
                  </div>
                  <div class="province-count">{{ province.count }}</div>
                </div>

                <div class="province-details">
                  <div class="province-stat">
                    <span class="stat-label">Ciudades:</span>
                    <span class="stat-value">{{ province.cities.length }}</span>
                  </div>
                  <div class="province-stat">
                    <span class="stat-label">Porcentaje:</span>
                    <span class="stat-value"
                      >{{
                        ((province.count / totalUsers()) * 100).toFixed(1)
                      }}%</span
                    >
                  </div>
                </div>

                <div class="top-cities">
                  <small class="cities-label">Principales ciudades:</small>
                  <div class="cities-list">
                    <span
                      v-for="city in province.topCities.slice(0, 3)"
                      :key="city.name"
                      class="city-tag"
                    >
                      {{ city.name }} ({{ city.count }})
                    </span>
                  </div>
                </div>

                <div class="province-actions" v-if="province.cities.length > 3">
                  <button
                    class="btn-details"
                    @click="toggleProvinceDetails(province.name)"
                  >
                    {{
                      expandedProvinces.includes(province.name)
                        ? "Ocultar detalles"
                        : "Ver todos"
                    }}
                  </button>
                </div>

                <div
                  v-if="expandedProvinces.includes(province.name)"
                  class="expanded-details"
                >
                  <div class="all-cities">
                    <strong>Todas las ciudades:</strong>
                    <div class="cities-grid-simple">
                      <div
                        v-for="city in province.cities"
                        :key="city.name"
                        class="city-item"
                      >
                        <span class="city-name">{{ city.name }}</span>
                        <span class="city-users">{{ city.count }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="filteredAndSortedProvinces.length === 0"
              class="no-provinces-found"
            >
              <i class="fas fa-search"></i>
              <p>
                No se encontraron provincias que coincidan con "{{
                  provinceSearchTerm
                }}"
              </p>
            </div>
          </div> -->
        </div>

        <!-- City List Section -->
        <div
          class="row mt-5"
          v-if="usersByCity && Object.keys(usersByCity).length"
        >
          <div class="col-12">
            <h5 class="title">
              <i class="fas fa-city"></i>
              Usuarios por Ciudad
            </h5>

            <!-- City Search and Filters -->
            <div class="row mb-3">
              <!-- <div class="col-md-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Buscar ciudad..."
                  v-model="citySearchTerm"
                />
              </div> -->
              <div class="col-md-4">
                <select class="form-control" v-model="cityUserTypeFilter">
                  <option value="all">Todos</option>
                  <option value="merchant">Tenderos</option>
                  <option value="freelance">Freelance</option>
                  <option value="ambassador">Embajadores</option>
                </select>
              </div>
              <!-- <div class="col-md-4">
                <select class="form-control" v-model="citySortOrder">
                  <option value="count-desc">Mayor cantidad primero</option>
                  <option value="alphabetical">Orden alfabético</option>
                  <option value="count-asc">Menor cantidad primero</option>
                </select>
              </div> -->
            </div>

            <!-- Cities Grid -->
            <div class="cities-grid">
              <div
                v-for="(city, index) in filteredAndSortedCities"
                :key="city.name"
                class="city-card"
              >
                <div class="city-header">
                  <div class="city-info">
                    <span
                      class="city-rank"
                      v-if="citySortOrder === 'count-desc'"
                    >
                      #{{ index + 1 }}
                    </span>
                    <h6 class="city-name">{{ city.name }}</h6>
                  </div>
                  <div class="city-count">{{ city.count }}</div>
                </div>

                <div class="city-details">
                  <div class="city-province">{{ city.province }}</div>
                  <div class="city-percentage">{{ city.percentage }}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Map Section -->
        <div class="row mt-5" v-if="salesWithCoordinates.length > 0">
          <div class="col-12">
            <h5 class="title">
              <i class="fas fa-map-marked-alt"></i>
              Mapa de Ventas por Ubicación
            </h5>

            <!-- Map Statistics -->
            <div class="row mb-3">
              <div class="col-md-3">
                <div class="map-stat-card">
                  <div class="stat-value">
                    {{ salesWithCoordinates.length }}
                  </div>
                  <div class="stat-label">Ventas con Ubicación</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="map-stat-card">
                  <div class="stat-value">{{ fastSalesCount }}</div>
                  <div class="stat-label">Ventas Rápidas (≤7 días)</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="map-stat-card">
                  <div class="stat-value">{{ moderateSalesCount }}</div>
                  <div class="stat-label">Ventas Moderadas (8-14 días)</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="map-stat-card">
                  <div class="stat-value">{{ slowSalesCount }}</div>
                  <div class="stat-label">Ventas Lentas (>14 días)</div>
                </div>
              </div>
            </div>

            <!-- Map Legend -->
            <div class="map-legend mb-3">
              <h6 class="legend-title">Leyenda de Tiempo de Cierre:</h6>
              <div class="legend-items">
                <div class="legend-item">
                  <div
                    class="legend-color"
                    style="background-color: #28a745"
                  ></div>
                  <span>0-7 días (Rápido)</span>
                </div>
                <div class="legend-item">
                  <div
                    class="legend-color"
                    style="background-color: #fd7e14"
                  ></div>
                  <span>8-14 días (Moderado)</span>
                </div>
                <div class="legend-item">
                  <div
                    class="legend-color"
                    style="background-color: #ffc107"
                  ></div>
                  <span>15-30 días (Lento)</span>
                </div>
                <div class="legend-item">
                  <div
                    class="legend-color"
                    style="background-color: #dc3545"
                  ></div>
                  <span>+30 días (Muy Lento)</span>
                </div>
              </div>
            </div>

            <!-- Map Container -->
            <div id="sales-map" class="map-container"></div>
          </div>
        </div>

        <!-- Empty State for Map -->
        <div class="row mt-5" v-else>
          <div class="col-12">
            <h5 class="title">
              <i class="fas fa-map-marked-alt"></i>
              Mapa de Ventas por Ubicación
            </h5>
            <div class="map-empty">
              <i class="fas fa-map-marker-alt"></i>
              <p>
                No hay ventas con coordenadas disponibles para mostrar en el
                mapa
              </p>
            </div>
          </div>
        </div>

        <!-- Sales Without Coverage Map Section -->
        <div
          class="row mt-5"
          v-if="salesWithoutCoverageWithCoordinates.length > 0"
        >
          <div class="col-12">
            <h5 class="title">
              <i class="fas fa-map-marked-alt text-danger"></i>
              Mapa de Ventas Sin Cobertura
            </h5>

            <!-- Map Statistics -->
            <div class="row mb-3">
              <div class="col-md-3">
                <div class="map-stat-card">
                  <div class="stat-value text-danger">
                    {{ salesWithoutCoverageWithCoordinates.length }}
                  </div>
                  <div class="stat-label">
                    Ventas Sin Cobertura con Ubicación
                  </div>
                </div>
              </div>

              <div class="col-md-9 map-legend mb-3">
                <h6 class="legend-title">Leyenda de Ventas Sin Cobertura:</h6>
                <div class="legend-items">
                  <div class="legend-item">
                    <div
                      class="legend-color"
                      style="background-color: #dc3545"
                    ></div>
                    <span>Ventas Sin Cobertura</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Map Container -->
            <div id="no-coverage-map" class="map-container"></div>
          </div>
        </div>

        <!-- Empty State for No Coverage Map -->
        <div class="row mt-5" v-else-if="salesWithoutCoverageTotal > 0">
          <div class="col-12">
            <h5 class="title">
              <i class="fas fa-map-marked-alt text-danger"></i>
              Mapa de Ventas Sin Cobertura
            </h5>
            <div class="map-empty">
              <i class="fas fa-map-marker-alt text-danger"></i>
              <p>
                Hay {{ salesWithoutCoverageTotal }} ventas sin cobertura, pero
                no tienen coordenadas disponibles para mostrar en el mapa
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { GChart } from "vue-google-charts";
import moment from "moment";
import Skeletor from "vue-skeletor";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix for default markers in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "Resumen",
  components: {
    GChart,
    Skeletor,
  },
  data() {
    return {
      from: "",
      to: "",
      datesValid: false,
      users: [],
      usersByCity: {},
      sales: [],
      totalBalance: 0,
      topTenBalancesWithNames: [],
      topTenSellersWithNames: [],
      loadingChart: false,
      hasData: true,
      report: {
        totalSales: 0,
        currentMonthSales: 0,
        currentMonthSalesPendingInst: 0,
        salesWithoutCoverage: 0,
        salesNotInterested: 0,
        salesNoAnswer: 0,
        salesInNegotiation: 0,
        totalUsers: 0,
        usersList: [],
      },
      options: {
        title: "Registros de Usuarios por Fecha y Ciudad",
        width: "100%",
        height: 500,
        legend: { position: "bottom" },
        colors: [
          "#830b83",
          "#f9cc03",
          "#4CAF50",
          "#ff5722",
          "#9c27b0",
          "#2196f3",
        ],
        backgroundColor: "transparent",
        animation: {
          duration: 1000,
          easing: "out",
        },
        chartArea: {
          width: "80%",
          height: "70%",
        },
        hAxis: {
          title: "Fecha",
          textStyle: {
            fontSize: 12,
          },
          slantedText: true,
          slantedTextAngle: 45,
        },
        vAxis: {
          title: "Cantidad de Usuarios",
          textStyle: {
            fontSize: 12,
          },
        },
        isStacked: true,
        tooltip: {
          isHtml: true,
        },
      },
      data: [
        ["Fecha", "Registros"],
        ["Cargando...", 0],
      ],
      // City chart configuration
      cityChartOptions: {
        title: "Top 10 Ciudades por Usuarios",
        width: "100%",
        height: 500,
        legend: { position: "bottom" },
        colors: [
          "#830b83",
          "#f9cc03",
          "#4CAF50",
          "#ff5722",
          "#9c27b0",
          "#2196f3",
          "#ff9800",
          "#795548",
          "#607d8b",
          "#e91e63",
        ],
        backgroundColor: "transparent",
        animation: {
          duration: 1000,
          easing: "out",
        },
        chartArea: {
          width: "80%",
          height: "70%",
        },
        hAxis: {
          title: "Ciudad",
          textStyle: {
            fontSize: 12,
          },
          slantedText: true,
          slantedTextAngle: 45,
        },
        vAxis: {
          title: "Cantidad de Usuarios",
          textStyle: {
            fontSize: 12,
          },
          minValue: 0,
          format: "0",
        },
        isStacked: false,
        focusTarget: "category",
        tooltip: { showColorCode: true },
      },
      cityChartData: [
        ["Ciudad", "Usuarios"],
        ["Cargando...", 0],
      ],
      areaChartOptions: {
        title: "Tendencia de Ventas en el Tiempo",
        width: "100%",
        height: 500,
        legend: { position: "bottom" },
        colors: ["#f9cc03", "#830b83"],
        backgroundColor: "transparent",
        animation: {
          duration: 1000,
          easing: "out",
        },
        chartArea: {
          width: "80%",
          height: "70%",
        },
        hAxis: {
          title: "Fecha",
          textStyle: {
            fontSize: 12,
          },
          slantedText: true,
          slantedTextAngle: 45,
        },
        vAxis: {
          title: "Cantidad de Ventas",
          textStyle: {
            fontSize: 12,
          },
        },
        isStacked: true,
        areaOpacity: 0.6,
      },
      areaChartData: [
        ["Fecha", "Ventas Instaladas", "Otras Ventas"],
        ["Cargando...", 0, 0],
      ],
      barChartOptions: {
        title: "Distribución de Ventas por Categoría",
        width: "100%",
        height: 500,
        legend: { position: "top", alignment: "center" },
        colors: ["#f9cc03", "#4CAF50", "#ff5722", "#9c27b0", "#2196f3"],
        backgroundColor: "transparent",
        animation: {
          duration: 1000,
          easing: "out",
        },
        chartArea: {
          width: "85%",
          height: "70%",
        },
        bar: { groupWidth: "70%" },
        hAxis: {
          title: "Categoría",
          textStyle: {
            fontSize: 12,
          },
        },
        vAxis: {
          title: "Cantidad de Ventas",
          textStyle: {
            fontSize: 12,
          },
          minValue: 0,
          format: "0",
        },
        isStacked: false,
        focusTarget: "category",
        tooltip: { showColorCode: true },
      },
      barChartData: [
        [
          "Categoría",
          "Instaladas",
          "Pendientes",
          "Sin Cobertura",
          "No Interesado",
          "En Negociación",
        ],
        ["Cargando...", 0, 0, 0, 0, 0],
      ],
      totalPeriodSales: 0,
      totalInstalledSales: 0,
      totalOtherSales: 0,
      installedPercentage: 0,
      otherPercentage: 0,
      averageDailySales: 0,
      totalPendingSales: 0,
      pendingPercentage: 0,
      totalNoCoverageSales: 0,
      noCoveragePercentage: 0,
      totalNotInterestedSales: 0,
      notInterestedPercentage: 0,
      totalInNegotiationSales: 0,
      inNegotiationPercentage: 0,
      usersByProvince: {},
      provinceSearchTerm: "",
      provinceSortOrder: "count-desc",
      expandedProvinces: [],
      citySearchTerm: "",
      citySortOrder: "count-desc",
      usersByCity: {},
      groupedUsersByCity: {},
      cityUserTypeFilter: "all",
      usersByUserType: {},
      // Ecuador provinces mapping
      ecuadorProvinces: {
        Azuay: [
          "Cuenca",
          "Gualaceo",
          "Paute",
          "Santa Isabel",
          "Sigsig",
          "Chordeleg",
          "El Pan",
          "Girón",
          "Guachapala",
          "Nabón",
          "Oña",
          "Pucará",
          "San Fernando",
          "Sevilla de Oro",
          "Camilo Ponce Enríquez",
        ],
        Bolívar: [
          "Guaranda",
          "Chillanes",
          "Chimbo",
          "Echeandía",
          "Las Naves",
          "Caluma",
          "San Miguel",
        ],
        Cañar: [
          "Azogues",
          "Biblián",
          "Cañar",
          "La Troncal",
          "El Tambo",
          "Déleg",
          "Suscal",
        ],
        Carchi: [
          "Tulcán",
          "Bolívar",
          "Espejo",
          "Mira",
          "Montúfar",
          "San Pedro de Huaca",
        ],
        Chimborazo: [
          "Riobamba",
          "Alausí",
          "Chambo",
          "Chunchi",
          "Colta",
          "Cumandá",
          "Guamote",
          "Guano",
          "Pallatanga",
          "Penipe",
        ],
        Cotopaxi: [
          "Latacunga",
          "La Maná",
          "Pangua",
          "Pujilí",
          "Salcedo",
          "Saquisilí",
          "Sigchos",
        ],
        "El Oro": [
          "Machala",
          "Arenillas",
          "Atahualpa",
          "Balsas",
          "Chilla",
          "El Guabo",
          "Huaquillas",
          "Las Lajas",
          "Marcabelí",
          "Pasaje",
          "Piñas",
          "Portovelo",
          "Santa Rosa",
          "Zaruma",
        ],
        Esmeraldas: [
          "Esmeraldas",
          "Eloy Alfaro",
          "Muisne",
          "Quinindé",
          "San Lorenzo",
          "Atacames",
        ],
        Galápagos: [
          "Puerto Baquerizo Moreno",
          "Puerto Ayora",
          "Puerto Villamil",
        ],
        Guayas: [
          "Guayaquil",
          "Alfredo Baquerizo Moreno",
          "Balao",
          "Balzar",
          "Colimes",
          "Coronel Marcelino Maridueña",
          "Daule",
          "Durán",
          "El Empalme",
          "El Triunfo",
          "Milagro",
          "Naranjal",
          "Naranjito",
          "Palestina",
          "Pedro Carbo",
          "Playas",
          "Salitre",
          "Samborondón",
          "Santa Lucía",
          "Simón Bolívar",
          "Yaguachi",
          "Isidro Ayora",
          "Lomas de Sargentillo",
          "Nobol",
          "General Antonio Elizalde",
        ],
        Imbabura: [
          "Ibarra",
          "Antonio Ante",
          "Cotacachi",
          "Otavalo",
          "Pimampiro",
          "San Miguel de Urcuquí",
        ],
        Loja: [
          "Loja",
          "Calvas",
          "Catamayo",
          "Celica",
          "Chaguarpamba",
          "Espíndola",
          "Gonzanamá",
          "Macará",
          "Paltas",
          "Pindal",
          "Puyango",
          "Saraguro",
          "Sozoranga",
          "Zapotillo",
          "Paquisha",
          "Quilanga",
        ],
        "Los Ríos": [
          "Babahoyo",
          "Baba",
          "Montalvo",
          "Puebloviejo",
          "Quevedo",
          "Urdaneta",
          "Ventanas",
          "Vínces",
          "Palenque",
          "Buena Fe",
          "Valencia",
          "Mocache",
          "Quinsaloma",
        ],
        Manabí: [
          "Portoviejo",
          "Bolívar",
          "Chone",
          "El Carmen",
          "Flavio Alfaro",
          "Jipijapa",
          "Junín",
          "Manta",
          "Montecristi",
          "Paján",
          "Pichincha",
          "Rocafuerte",
          "Santa Ana",
          "Sucre",
          "Tosagua",
          "Veinticuatro de Mayo",
          "Pedernales",
          "Olmedo",
          "Puerto López",
          "Jama",
          "Jaramijó",
          "San Vicente",
        ],
        "Morona Santiago": [
          "Macas",
          "Gualaquiza",
          "Limón Indanza",
          "Palora",
          "Santiago",
          "Sucúa",
          "Huamboya",
          "San Juan Bosco",
          "Taisha",
          "Logroño",
          "Pablo Sexto",
          "Tiwintza",
        ],
        Napo: [
          "Tena",
          "Archidona",
          "El Chaco",
          "Quijos",
          "Carlos Julio Arosemena Tola",
        ],
        Orellana: [
          "Francisco de Orellana",
          "Aguarico",
          "La Joya de los Sachas",
          "Loreto",
        ],
        Pastaza: ["Puyo", "Arajuno", "Mera", "Santa Clara"],
        Pichincha: [
          "Quito",
          "Cayambe",
          "Mejía",
          "Pedro Moncayo",
          "Rumiñahui",
          "San Miguel de los Bancos",
          "Pedro Vicente Maldonado",
          "Puerto Quito",
        ],
        "Santa Elena": ["Santa Elena", "La Libertad", "Salinas"],
        "Santo Domingo de los Tsáchilas": ["Santo Domingo"],
        Sucumbíos: [
          "Nueva Loja",
          "Gonzalo Pizarro",
          "Lago Agrio",
          "Putumayo",
          "Shushufindi",
          "Sucumbíos",
          "Cascales",
        ],
        Tungurahua: [
          "Ambato",
          "Baños de Agua Santa",
          "Cevallos",
          "Mocha",
          "Patate",
          "Quero",
          "San Pedro de Pelileo",
          "Santiago de Píllaro",
          "Tisaleo",
        ],
        "Zamora Chinchipe": [
          "Zamora",
          "Chinchipe",
          "El Pangui",
          "Nangaritza",
          "Palanda",
          "Paquisha",
          "Yacuambi",
          "Yantzaza",
          "Centinela del Cóndor",
        ],
      },
      // Deal closing time statistics
      dealClosingStats: {
        totalSales: 0,
        averageClosingTime: {
          minutes: 0,
          hours: 0,
          days: 0,
        },
        medianClosingTime: {
          minutes: 0,
          hours: 0,
          days: 0,
        },
        fastestSale: {
          saleId: null,
          referrerName: "",
          closingTime: {
            minutes: 0,
            hours: 0,
            days: 0,
          },
        },
        slowestSale: {
          saleId: null,
          referrerName: "",
          closingTime: {
            minutes: 0,
            hours: 0,
            days: 0,
          },
        },
      },
      salesDetails: [],
      // Map configuration
      map: null,
      noCoverageMap: null,
      mapZoom: 6,
      mapCenter: [-1.8312, -78.1834], // Ecuador center coordinates
      tileLayerUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      tileLayerAttribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      otherCitiesBreakdown: [],
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY");
    },
    initializeDates() {
      // Set initial date to first day of current month
      this.from = moment().startOf("month").format("YYYY-MM-DD");
      // Set end date to current day
      this.to = moment().format("YYYY-MM-DD");
      this.validateDates();
    },
    validateDates() {
      if (this.from && this.to) {
        const fromDate = new Date(this.from);
        const toDate = new Date(this.to);
        this.datesValid = fromDate <= toDate;
      } else {
        this.datesValid = false;
      }
    },
    processChartData(users) {
      // Group users by registration date
      const recordsByDate = {};
      if (users && users.length > 0) {
        this.hasData = true;
        users.forEach((user) => {
          const date = user.dateRegister.split(",")[0]; // Get only the date
          recordsByDate[date] = (recordsByDate[date] || 0) + 1;
        });

        // Convert to chart format
        this.data = [
          ["Fecha", "Registros"],
          ...Object.entries(recordsByDate).map(([date, count]) => [
            date,
            count,
          ]),
        ];

        // Brief delay to ensure DOM updates before rendering chart
        this.loadingChart = true;
        setTimeout(() => {
          this.loadingChart = false;
        }, 100);
      } else {
        // If no data, set hasData flag to show message
        this.hasData = false;
        this.data = [
          ["Fecha", "Registros"],
          ["No data", 0],
        ];
        this.loadingChart = false;
      }
    },
    getAverageDealClosingTime() {
      this.$https
        .post("/administration/fetchAverageDealClosingTime", {
          tokenAuth: this.$store.state.tokenAuth,
          userId: this.$store.state.user.userId,
          role: this.$store.state.user.role,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.dealClosingStats = res.data.statistics;
            this.salesDetails = res.data.salesDetails || [];
            console.log("Deal closing statistics:", this.dealClosingStats);
          } else {
            this.$toast.error("Error getting deal closing statistics");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error getting deal closing statistics");
        });
    },
    getSalesWithoutCoverage() {
      this.$https
        .post("/administration/fetchSalesWithoutCoverage", {
          tokenAuth: this.$store.state.tokenAuth,
          userId: this.$store.state.user.userId,
          role: this.$store.state.user.role,
        })
        .then((res) => {
          if (res.data.code === 200) {
            // Merge with existing salesDetails, ensuring no duplicates
            const noCoverageSales = res.data.sales || [];

            // Add no coverage sales to salesDetails if they're not already there
            noCoverageSales.forEach((noCoverageSale) => {
              const exists = this.salesDetails.find(
                (sale) => sale.saleId === noCoverageSale.saleId,
              );
              if (!exists) {
                this.salesDetails.push(noCoverageSale);
              }
            });

            console.log("Sales without coverage:", noCoverageSales);
          } else {
            console.warn("No sales without coverage data available");
          }
        })
        .catch((err) => {
          console.error(err);
          console.warn(
            "Error getting sales without coverage - endpoint might not exist yet",
          );
        });
    },
    getSummary() {
      this.loadingChart = true;
      if (!this.datesValid) {
        this.$toast.error("Please select valid dates");
        return;
      }

      // Fetch sales report data
      this.$https
        .post("/whatsapp/getReportePeriodoVentas", {
          fechaInicio: moment(this.from).format("DD/MM/YYYY"),
          fechaFin: moment(this.to).format("DD/MM/YYYY"),
        })
        .then((res) => {
          if (res.data.code === 200) {
            // Map the response data to our new English property names
            this.report = {
              totalSales: res.data.cantidadVentas,
              currentMonthSales: res.data.cantidadVentasMesActual,
              currentMonthSalesPendingInst:
                res.data.cantidadVentasMesActualPendInst,
              salesWithoutCoverage: res.data.cantidadVentasSinCobertura,
              salesNotInterested: res.data.cantidadVentasNoDesea,
              salesNoAnswer: res.data.cantidadVentasNoContesta,
              salesInNegotiation: res.data.cantidadVentasEnNegociacion,
              totalUsers: res.data.cantidadUsuarios,
              usersList: res.data.listadoUsuarios || [],
            };

            console.log("usersList", this.report.usersList);

            // Fetch chart data
            this.fetchChartData();
          } else {
            this.$toast.error("Error getting data");
            this.hasData = false;
            this.loadingChart = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error getting data");
          this.hasData = false;
          this.loadingChart = false;
        });
    },
    fetchChartData() {
      this.$https
        .post("/administration/fetchSalesChartData", {
          tokenAuth: this.$store.state.tokenAuth,
          role: this.$store.state.user.role,
          userId: this.$store.state.user.userId,
          fechaInicio: moment(this.from).format("DD/MM/YYYY"),
          fechaFin: moment(this.to).format("DD/MM/YYYY"),
        })
        .then((res) => {
          if (res.data.code === 200 && res.data.chartData.length > 0) {
            this.hasData = true;

            // Process user registration data for the first chart
            if (this.report.usersList && this.report.usersList.length > 0) {
              const recordsByDate = {};
              const recordsByCity = {};
              const recordsByDateAndCity = {}; // New structure for stacked chart

              this.report.usersList.forEach((user) => {
                console.log("user", user);
                const date = user.dateRegister.split(",")[0]; // Get only the date
                const city = user.city || "Sin Ciudad";

                // Original date grouping
                recordsByDate[date] = (recordsByDate[date] || 0) + 1;

                // City grouping for separate chart
                recordsByCity[city] = (recordsByCity[city] || 0) + 1;

                // New: Group by date and city for stacked chart
                if (!recordsByDateAndCity[date]) {
                  recordsByDateAndCity[date] = {};
                }
                recordsByDateAndCity[date][city] =
                  (recordsByDateAndCity[date][city] || 0) + 1;
              });

              // Get top 5 cities for the stacked chart (to keep it readable)
              const topCities = Object.entries(recordsByCity)
                .sort((a, b) => b[1] - a[1])
                .slice(0, 5)
                .map(([city, count]) => city);

              // Store "Otras Ciudades" breakdown for legend
              this.otherCitiesBreakdown = Object.entries(recordsByCity)
                .filter(([city, count]) => !topCities.includes(city))
                .sort((a, b) => b[1] - a[1]);

              // Create stacked chart data
              const dates = Object.keys(recordsByDateAndCity).sort();

              // Create header with date and top cities, plus tooltip columns
              const stackedChartHeader = [
                "Fecha",
                ...topCities,
                "Otras Ciudades",
                { type: "string", role: "tooltip", p: { html: true } },
              ];

              // Create data rows for each date
              const stackedChartRows = dates.map((date) => {
                const row = [date];
                let otherCitiesCount = 0;
                const otherCitiesForThisDate = [];

                // Add counts for top cities
                topCities.forEach((city) => {
                  const count = recordsByDateAndCity[date][city] || 0;
                  row.push(count);
                });

                // Calculate "Otras Ciudades" count and collect cities for tooltip
                Object.entries(recordsByDateAndCity[date]).forEach(
                  ([city, count]) => {
                    if (!topCities.includes(city)) {
                      otherCitiesCount += count;
                      otherCitiesForThisDate.push({ city, count });
                    }
                  },
                );

                // Sort other cities by count for this date
                otherCitiesForThisDate.sort((a, b) => b.count - a.count);

                // Create HTML tooltip for "Otras Ciudades"
                let tooltipHtml = `<div style="padding: 10px; font-family: Arial, sans-serif;">
                  <div style="font-weight: bold; margin-bottom: 8px; color: #333;">
                    Otras Ciudades - ${date}
                  </div>
                  <div style="font-weight: bold; margin-bottom: 8px; color: #830b83;">
                    Total: ${otherCitiesCount} usuarios
                  </div>`;

                if (otherCitiesForThisDate.length > 0) {
                  tooltipHtml += `<div style="border-top: 1px solid #eee; padding-top: 8px;">
                    <div style="font-weight: bold; margin-bottom: 5px; font-size: 0.9em;">Desglose por ciudad:</div>`;

                  otherCitiesForThisDate.forEach(({ city, count }) => {
                    tooltipHtml += `<div style="display: flex; justify-content: space-between; margin-bottom: 3px; font-size: 0.85em;">
                      <span>${city}:</span>
                      <span style="color: #830b83; font-weight: bold;">${count}</span>
                    </div>`;
                  });

                  tooltipHtml += `</div>`;
                } else {
                  tooltipHtml += `<div style="color: #666; font-style: italic;">No hay ciudades adicionales en esta fecha</div>`;
                }

                tooltipHtml += `</div>`;

                row.push(otherCitiesCount);
                row.push(tooltipHtml);
                return row;
              });

              // Update the main chart to be stacked
              this.data = [stackedChartHeader, ...stackedChartRows];

              // Create city chart data - get top 10 cities and sort by count
              const sortedCities = Object.entries(recordsByCity)
                .sort((a, b) => b[1] - a[1])
                .slice(0, 10); // Top 10 cities

              // Create chart data with each city as a separate data row
              this.cityChartData = [
                ["Ciudad", "Usuarios"],
                ...sortedCities.map(([city, count]) => [city, count]),
              ];

              console.log("data (stacked):", this.data);
              console.log("cityChartData", this.cityChartData);
              console.log("otherCitiesBreakdown", this.otherCitiesBreakdown);
            } else {
              this.data = [
                [
                  "Fecha",
                  "Sin datos",
                  "Otras Ciudades",
                  { type: "string", role: "tooltip", p: { html: true } },
                ],
                ["Sin datos", 0, 0, "<div>No hay datos disponibles</div>"],
              ];
              this.cityChartData = [
                ["Ciudad", "Sin datos"],
                ["Usuarios", 0],
              ];
              this.otherCitiesBreakdown = [];
            }

            // Format chart data for Area Chart (Sales data by date)
            this.areaChartData = [
              ["Fecha", "Ventas Instaladas", "Otras Ventas"],
              ...res.data.chartData.map((item) => [
                item.date,
                item.installedSales,
                item.otherSales,
              ]),
            ];

            // Create sorted area chart data
            // Sort dates in ascending order for proper trend visualization
            const sortedData = [...res.data.chartData].sort(
              (a, b) => new Date(a.date) - new Date(b.date),
            );

            // Update area chart with sorted data
            this.areaChartData = [
              ["Fecha", "Ventas Instaladas", "Otras Ventas"],
              ...sortedData.map((item) => [
                item.date,
                item.installedSales,
                item.otherSales,
              ]),
            ];

            // Calculate totals for charts
            this.totalInstalledSales = this.report.totalSales || 0;
            this.totalPendingSales =
              this.report.currentMonthSalesPendingInst || 0;
            this.totalNoCoverageSales = this.report.salesWithoutCoverage || 0;
            this.totalNotInterestedSales =
              (this.report.salesNotInterested || 0) +
              (this.report.salesNoAnswer || 0);
            this.totalInNegotiationSales = this.report.salesInNegotiation || 0;

            this.totalPeriodSales =
              this.totalInstalledSales +
              this.totalPendingSales +
              this.totalNoCoverageSales +
              this.totalNotInterestedSales +
              this.totalInNegotiationSales;

            // Calculate percentages
            if (this.totalPeriodSales > 0) {
              this.installedPercentage = Math.round(
                (this.totalInstalledSales / this.totalPeriodSales) * 100,
              );
              this.pendingPercentage = Math.round(
                (this.totalPendingSales / this.totalPeriodSales) * 100,
              );
              this.noCoveragePercentage = Math.round(
                (this.totalNoCoverageSales / this.totalPeriodSales) * 100,
              );
              this.notInterestedPercentage = Math.round(
                (this.totalNotInterestedSales / this.totalPeriodSales) * 100,
              );
              this.inNegotiationPercentage = Math.round(
                (this.totalInNegotiationSales / this.totalPeriodSales) * 100,
              );
            } else {
              this.installedPercentage = 0;
              this.pendingPercentage = 0;
              this.noCoveragePercentage = 0;
              this.notInterestedPercentage = 0;
              this.inNegotiationPercentage = 0;
            }

            // Calculate average daily sales
            const uniqueDates = new Set(
              res.data.chartData.map((item) => item.date),
            );
            this.averageDailySales =
              uniqueDates.size > 0
                ? (this.totalPeriodSales / uniqueDates.size).toFixed(1)
                : 0;

            // Update bar chart data with detailed categories
            this.barChartData = [
              [
                "Categoría",
                "Instaladas",
                "Pendientes",
                "Sin Cobertura",
                "No Interesado",
                "En Negociación",
              ],
              [
                "Ventas",
                this.totalInstalledSales,
                this.totalPendingSales,
                this.totalNoCoverageSales,
                this.totalNotInterestedSales,
                this.totalInNegotiationSales,
              ],
            ];
          } else {
            this.hasData = false;
            this.data = [
              [
                "Fecha",
                "Sin datos",
                "Otras Ciudades",
                { type: "string", role: "tooltip", p: { html: true } },
              ],
              ["Sin datos", 0, 0, "<div>No hay datos disponibles</div>"],
            ];
            this.cityChartData = [
              ["Ciudad", "Sin datos"],
              ["Usuarios", 0],
            ];
            this.areaChartData = [
              ["Fecha", "Ventas Instaladas", "Otras Ventas"],
              ["Sin datos", 0, 0],
            ];
            this.barChartData = [
              [
                "Categoría",
                "Instaladas",
                "Pendientes",
                "Sin Cobertura",
                "No Interesado",
                "En Negociación",
              ],
              ["Sin datos", 0, 0, 0, 0, 0],
            ];
            this.resetChartData();
          }
          // Fetch sales without coverage data after chart data is processed
          this.getSalesWithoutCoverage();
          this.loadingChart = false;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error getting chart data");
          this.hasData = false;
          this.data = [
            [
              "Fecha",
              "Error",
              "Otras Ciudades",
              { type: "string", role: "tooltip", p: { html: true } },
            ],
            ["Error", 0, 0, "<div>Error al obtener datos</div>"],
          ];
          this.cityChartData = [
            ["Ciudad", "Error"],
            ["Usuarios", 0],
          ];
          this.areaChartData = [
            ["Fecha", "Ventas Instaladas", "Otras Ventas"],
            ["Error", 0, 0],
          ];
          this.barChartData = [
            [
              "Categoría",
              "Instaladas",
              "Pendientes",
              "Sin Cobertura",
              "No Interesado",
              "En Negociación",
            ],
            ["Error", 0, 0, 0, 0, 0],
          ];
          this.resetChartData();
          this.loadingChart = false;
        });
    },
    resetChartData() {
      this.totalPeriodSales = 0;
      this.totalInstalledSales = 0;
      this.totalOtherSales = 0;
      this.installedPercentage = 0;
      this.otherPercentage = 0;
      this.averageDailySales = 0;
      this.totalPendingSales = 0;
      this.pendingPercentage = 0;
      this.totalNoCoverageSales = 0;
      this.noCoveragePercentage = 0;
      this.totalNotInterestedSales = 0;
      this.notInterestedPercentage = 0;
      this.totalInNegotiationSales = 0;
      this.inNegotiationPercentage = 0;
    },
    countSales() {
      return this.sales.length;
    },
    countInstalledSales() {
      return this.sales.filter(
        (sale) => sale.status === "INSTALADO: Contrato instalado",
      ).length;
    },
    countPendingSales() {
      return this.sales.filter((sale) => !sale.completed).length;
    },
    countNotPendingNotInstalledSales() {
      return this.sales.filter(
        (sale) =>
          sale.completed && sale.status !== "INSTALADO: Contrato instalado",
      ).length;
    },
    countUsersByCity() {
      // Filter users based on selected user type
      let filteredUsers = this.users.filter((user) => user.isVerified);

      if (this.cityUserTypeFilter !== "all") {
        const userTypeMap = {
          merchant: "merchant",
          freelance: "freelance",
          ambassador: "ambassador",
          user: "user",
        };

        const targetUserType = userTypeMap[this.cityUserTypeFilter];
        filteredUsers = filteredUsers.filter(
          (user) => user.userType === targetUserType,
        );
      }

      this.usersByCity = filteredUsers.reduce((acc, user) => {
        let city = user.city || "Sin Ciudad";
        acc[city] = (acc[city] || 0) + 1;
        return acc;
      }, {});

      const sortedCities = Object.keys(this.usersByCity).sort((a, b) => {
        if (a === "Sin Ciudad") return -1;
        if (b === "Sin Ciudad") return 1;
        return a.localeCompare(b);
      });

      this.usersByCity = sortedCities.reduce((acc, city) => {
        acc[city] = this.usersByCity[city];
        return acc;
      }, {});
    },
    totalUsers() {
      return this.users.length;
    },
    fetchTotalBalance() {
      this.$https
        .post("/administration/fetchWalletBalances", {
          tokenAuth: this.$store.state.tokenAuth,
          role: this.$store.state.user.role,
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          this.totalBalance = res.data.totalBalance;
          this.topTenBalancesWithNames = res.data.topTenBalancesWithNames;
          this.topTenSellersWithNames = res.data.topTenSellersWithNames;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error getting balances");
        });
    },
    getUsers() {
      this.$https
        .post("/administration/fetchUsersAdminStatistics", {
          tokenAuth: this.$store.state.tokenAuth,
          role: this.$store.state.user.role,
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          this.users = res.data.users;
          this.countUsersByCity();
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error getting users");
        });
    },
    getSales() {
      this.$https
        .post("/administration/fetchSalesAdmin", {
          tokenAuth: this.$store.state.tokenAuth,
          role: this.$store.state.user.role,
          userId: this.$store.state.user.userId,
        })
        .then((res) => {
          this.sales = res.data.sales;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error getting sales");
        });
    },
    groupUsersByCity() {
      // Group users from report.usersList by city
      const grouped = {};
      if (this.report.usersList && this.report.usersList.length > 0) {
        this.report.usersList.forEach((user) => {
          const city = user.city || "Sin Ciudad";
          if (!grouped[city]) {
            grouped[city] = [];
          }
          grouped[city].push(user);
        });
      }
      this.groupedUsersByCity = grouped;

      // Update usersByCity for compatibility
      this.usersByCity = Object.keys(grouped).reduce((acc, city) => {
        acc[city] = grouped[city].length;
        return acc;
      }, {});

      // Group by provinces
      this.groupUsersByProvinces();
    },
    groupUsersByProvinces() {
      const provinceGroups = {};

      // Initialize all provinces
      Object.keys(this.ecuadorProvinces).forEach((province) => {
        provinceGroups[province] = {
          count: 0,
          cities: [],
          users: [],
        };
      });

      // Add "Sin Provincia" for unmatched cities
      provinceGroups["Sin Provincia"] = {
        count: 0,
        cities: [],
        users: [],
      };

      // Group cities by provinces
      Object.entries(this.usersByCity).forEach(([city, count]) => {
        let matchedProvince = null;

        // Find which province this city belongs to
        for (const [province, cities] of Object.entries(
          this.ecuadorProvinces,
        )) {
          if (
            cities.some(
              (provinceCity) =>
                city.toLowerCase().includes(provinceCity.toLowerCase()) ||
                provinceCity.toLowerCase().includes(city.toLowerCase()),
            )
          ) {
            matchedProvince = province;
            break;
          }
        }

        // If no match found, assign to "Sin Provincia"
        if (!matchedProvince) {
          matchedProvince = "Sin Provincia";
        }

        provinceGroups[matchedProvince].count += count;
        provinceGroups[matchedProvince].cities.push({
          name: city,
          count: count,
        });

        // Add users if available
        if (this.groupedUsersByCity[city]) {
          provinceGroups[matchedProvince].users.push(
            ...this.groupedUsersByCity[city],
          );
        }
      });

      // Remove provinces with no users
      this.usersByProvince = Object.fromEntries(
        Object.entries(provinceGroups).filter(
          ([province, data]) => data.count > 0,
        ),
      );
    },
    getTopProvince() {
      if (
        !this.usersByProvince ||
        Object.keys(this.usersByProvince).length === 0
      ) {
        return { name: "N/A", count: 0 };
      }

      const provinces = Object.entries(this.usersByProvince);
      const topProvince = provinces.reduce(
        (max, [name, data]) =>
          data.count > max.count ? { name, count: data.count } : max,
        { name: "", count: 0 },
      );
      return topProvince;
    },
    getCityProvince(cityName) {
      for (const [province, cities] of Object.entries(this.ecuadorProvinces)) {
        if (
          cities.some((city) => city.toLowerCase() === cityName.toLowerCase())
        ) {
          return province;
        }
      }
      return "Sin Provincia";
    },
    toggleProvinceDetails(provinceName) {
      const currentState = this.expandedProvinces[provinceName] || false;
      this.$set(this.expandedProvinces, provinceName, !currentState);
    },
    formatClosingTime(timeObj) {
      if (!timeObj) return "N/A";

      const days = timeObj.days || 0;
      const hours = timeObj.hours || 0;
      const minutes = timeObj.minutes || 0;

      let result = [];

      if (days > 0) {
        result.push(`${days}d`);
      }
      if (hours > 0) {
        result.push(`${hours}h`);
      }
      if (minutes > 0 || result.length === 0) {
        result.push(`${minutes}m`);
      }

      return result.join(" ");
    },
    formatSaleInfo(sale) {
      if (!sale || !sale.referrerName) return "N/A";
      return `${sale.referrerName}`;
    },
    // Map methods
    onMapReady() {
      // Adjust map view to fit all markers
      this.$nextTick(() => {
        if (this.salesWithCoordinates.length > 0) {
          this.fitMapToMarkers();
        }
      });
    },
    fitMapToMarkers() {
      if (this.salesWithCoordinates.length === 0) return;

      this.$nextTick(() => {
        const mapComponent = this.$refs.map;
        if (mapComponent && mapComponent.leafletObject) {
          const bounds = L.latLngBounds();

          // Add all marker positions to bounds
          this.salesWithCoordinates.forEach((sale) => {
            bounds.extend([sale.latitude, sale.longitude]);
          });

          // Fit the map to show all markers
          mapComponent.leafletObject.fitBounds(bounds, { padding: [20, 20] });
        }
      });
    },
    getMarkerIcon(sale) {
      // Create different colored markers based on closing time
      const days = sale.timeDiffDays || 0;
      let color = "#28a745"; // Green for fast closures (0-7 days)

      if (days > 30) {
        color = "#dc3545"; // Red for slow closures (>30 days)
      } else if (days > 14) {
        color = "#ffc107"; // Yellow for medium closures (14-30 days)
      } else if (days > 7) {
        color = "#fd7e14"; // Orange for slower closures (7-14 days)
      }

      return L.divIcon({
        className: "custom-marker",
        html: `<div style="
          background-color: ${color};
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 2px solid white;
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 10px;
          font-weight: bold;
        ">${days}d</div>`,
        iconSize: [24, 24],
        iconAnchor: [12, 12],
        popupAnchor: [0, -12],
      });
    },
    initializeMap() {
      this.$nextTick(() => {
        // Clean up existing map
        if (this.map) {
          this.map.remove();
          this.map = null;
        }

        // Check if DOM element exists
        const mapElement = document.getElementById("sales-map");
        if (!mapElement) {
          console.warn("Sales map element not found");
          return;
        }

        // Add a small delay to ensure DOM is fully ready
        setTimeout(() => {
          try {
            // Initialize the map
            this.map = L.map("sales-map").setView(this.mapCenter, this.mapZoom);

            // Add tile layer
            L.tileLayer(this.tileLayerUrl, {
              attribution: this.tileLayerAttribution,
            }).addTo(this.map);

            // Add markers for sales with coordinates
            this.addSalesMarkers();

            // Fit map to show all markers
            this.fitMapToMarkers();
          } catch (error) {
            console.error("Error initializing sales map:", error);
          }
        }, 100);
      });
    },
    addSalesMarkers() {
      if (!this.map || !this.salesWithCoordinates.length) return;

      this.salesWithCoordinates.forEach((sale) => {
        const marker = L.marker([sale.latitude, sale.longitude]);

        // Create popup content
        const popupContent = `
          <div class="map-popup">
            <h6>${sale.referrerFullName}</h6>
            <p><strong>Ubicación:</strong> ${sale.latitude + ", " + sale.longitude || "No especificada"}</p>
            <p><strong>Tiempo de cierre:</strong> ${sale.timeDiffDays} días</p>
            <p><strong>Fecha creación:</strong> ${moment(sale.createdAt).format("DD/MM/YYYY")}</p>
            <p><strong>Fecha instalación:</strong> ${moment(sale.updatedOn).format("DD/MM/YYYY")}</p>
          </div>
        `;

        marker.bindPopup(popupContent);

        // Customize marker icon based on closing time
        const icon = this.getMarkerIcon(sale.timeDiffDays);
        marker.setIcon(icon);

        marker.addTo(this.map);
      });
    },
    getMarkerIcon(days) {
      let color;
      if (days <= 7) {
        color = "#28a745"; // Green - Fast
      } else if (days <= 14) {
        color = "#fd7e14"; // Orange - Moderate
      } else if (days <= 30) {
        color = "#ffc107"; // Yellow - Slow
      } else {
        color = "#dc3545"; // Red - Very Slow
      }

      return L.divIcon({
        className: "custom-marker",
        html: `<div style="background-color: ${color}; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
        iconSize: [20, 20],
        iconAnchor: [10, 10],
      });
    },
    fitMapToMarkers() {
      if (!this.map || !this.salesWithCoordinates.length) return;

      const bounds = L.latLngBounds();
      this.salesWithCoordinates.forEach((sale) => {
        bounds.extend([sale.latitude, sale.longitude]);
      });

      this.map.fitBounds(bounds, { padding: [20, 20] });
    },
    // No Coverage Map Methods
    initializeNoCoverageMap() {
      this.$nextTick(() => {
        // Clean up existing map
        if (this.noCoverageMap) {
          this.noCoverageMap.remove();
          this.noCoverageMap = null;
        }

        // Check if DOM element exists
        const noCoverageMapElement = document.getElementById("no-coverage-map");
        if (!noCoverageMapElement) {
          console.warn("No coverage map element not found");
          return;
        }

        // Add a small delay to ensure DOM is fully ready
        setTimeout(() => {
          try {
            // Initialize the no coverage map
            this.noCoverageMap = L.map("no-coverage-map").setView(
              this.mapCenter,
              this.mapZoom,
            );

            // Add tile layer
            L.tileLayer(this.tileLayerUrl, {
              attribution: this.tileLayerAttribution,
            }).addTo(this.noCoverageMap);

            // Add markers for sales without coverage
            this.addNoCoverageMarkers();

            // Fit map to show all markers
            this.fitNoCoverageMapToMarkers();
          } catch (error) {
            console.error("Error initializing no coverage map:", error);
          }
        }, 150); // Slightly longer delay to avoid conflicts with main map
      });
    },
    addNoCoverageMarkers() {
      if (
        !this.noCoverageMap ||
        !this.salesWithoutCoverageWithCoordinates.length
      )
        return;

      this.salesWithoutCoverageWithCoordinates.forEach((sale) => {
        const marker = L.marker([sale.latitude, sale.longitude]);

        // Create popup content
        const popupContent = `
          <div class="map-popup">
            <h6>${sale.referrerFullName}</h6>
            <p><strong>Estado:</strong> <span class="text-danger">Sin Cobertura</span></p>
            <p><strong>Coordenadas:</strong> ${sale.latitude + ", " + sale.longitude}</p>
            <p><strong>Fecha creación:</strong> ${moment(sale.createdAt).format("DD/MM/YYYY")}</p>
            <p><strong>Provincia:</strong> ${sale.province || "No especificada"}</p>
          </div>
        `;

        marker.bindPopup(popupContent);

        // Red marker for no coverage sales
        const icon = this.getNoCoverageMarkerIcon();
        marker.setIcon(icon);

        marker.addTo(this.noCoverageMap);
      });
    },
    getNoCoverageMarkerIcon() {
      return L.divIcon({
        className: "custom-marker",
        html: `<div style="
          background-color: #dc3545; 
          width: 20px; 
          height: 20px; 
          border-radius: 50%; 
          border: 2px solid white; 
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 10px;
          font-weight: bold;
        ">×</div>`,
        iconSize: [20, 20],
        iconAnchor: [10, 10],
      });
    },
    fitNoCoverageMapToMarkers() {
      if (
        !this.noCoverageMap ||
        !this.salesWithoutCoverageWithCoordinates.length
      )
        return;

      const bounds = L.latLngBounds();
      this.salesWithoutCoverageWithCoordinates.forEach((sale) => {
        bounds.extend([sale.latitude, sale.longitude]);
      });

      this.noCoverageMap.fitBounds(bounds, { padding: [20, 20] });
    },
  },
  computed: {
    filteredAndSortedCities() {
      const searchTerm = this.citySearchTerm.toLowerCase();

      // Filter cities based on search term
      const filtered = Object.entries(this.usersByCity).filter(
        ([city, count]) => {
          return city.toLowerCase().includes(searchTerm);
        },
      );

      // Sort based on selected order
      const sorted = filtered.sort((a, b) => {
        const [cityA, countA] = a;
        const [cityB, countB] = b;

        switch (this.citySortOrder) {
          case "alphabetical":
            return cityA.localeCompare(cityB);
          case "count-asc":
            return countA - countB;
          case "count-desc":
          default:
            return countB - countA;
        }
      });

      // Calculate total filtered users for percentage calculation
      const totalFilteredUsers = Object.values(this.usersByCity).reduce(
        (sum, count) => sum + count,
        0,
      );

      return sorted.map(([city, count]) => ({
        name: city,
        province: this.getCityProvince(city),
        count: count,
        percentage:
          totalFilteredUsers > 0
            ? ((count / totalFilteredUsers) * 100).toFixed(1)
            : 0,
      }));
    },
    usersByProvince() {
      const provinces = {};
      Object.entries(this.usersByCity).forEach(([city, count]) => {
        const province = this.getCityProvince(city);
        if (!provinces[province]) {
          provinces[province] = {
            count: 0,
            cities: {},
          };
        }
        provinces[province].count += count;
        provinces[province].cities[city] = count;
      });
      return provinces;
    },
    cityStats() {
      const cities = Object.entries(this.usersByCity);
      const totalCities = cities.length;

      if (totalCities === 0) {
        return {
          totalCities: 0,
          topCity: null,
          maxConcentration: 0,
        };
      }

      const sortedCities = cities.sort((a, b) => b[1] - a[1]);
      const topCity = sortedCities[0];
      const maxConcentration =
        this.totalUsuarios > 0
          ? ((topCity[1] / this.totalUsuarios) * 100).toFixed(1)
          : 0;

      return {
        totalCities,
        topCity: {
          name: topCity[0],
          count: topCity[1],
        },
        maxConcentration,
      };
    },
    filteredAndSortedProvinces() {
      // Filter provinces based on search term
      let provinces = Object.entries(this.usersByProvince)
        .filter(([provinceName]) =>
          provinceName
            .toLowerCase()
            .includes(this.provinceSearchTerm.toLowerCase()),
        )
        .map(([provinceName, data]) => ({
          name: provinceName,
          count: data.count,
          cities: data.cities.sort((a, b) => b.count - a.count), // Sort cities by count
          topCities: data.cities.sort((a, b) => b.count - a.count).slice(0, 5), // Top 5 cities
          users: data.users || [],
        }));

      // Sort provinces based on selected order
      provinces.sort((a, b) => {
        if (this.provinceSortOrder === "alphabetical") {
          // Put "Sin Provincia" at the end for alphabetical sorting
          if (a.name === "Sin Provincia") return 1;
          if (b.name === "Sin Provincia") return -1;
          return a.name.localeCompare(b.name);
        } else if (this.provinceSortOrder === "count-desc") {
          return b.count - a.count;
        } else if (this.provinceSortOrder === "count-asc") {
          return a.count - b.count;
        }
        return 0;
      });

      return provinces;
    },
    // Map computed properties
    salesWithCoordinates() {
      return this.salesDetails.filter((sale) => {
        console.log("Sale", sale);
        return (
          sale.status === "INSTALADO: Contrato instalado" &&
          sale.latitude &&
          sale.longitude &&
          !isNaN(sale.latitude) &&
          !isNaN(sale.longitude) &&
          sale.latitude !== 0 &&
          sale.longitude !== 0
        );
      });
    },
    salesWithoutCoordinates() {
      return this.salesDetails.filter(
        (sale) =>
          !sale.latitude ||
          !sale.longitude ||
          isNaN(sale.latitude) ||
          isNaN(sale.longitude) ||
          sale.latitude === 0 ||
          sale.longitude === 0,
      );
    },
    averageClosingDays() {
      if (this.salesWithCoordinates.length === 0) return 0;
      const totalDays = this.salesWithCoordinates.reduce(
        (sum, sale) => sum + (sale.timeDiffDays || 0),
        0,
      );
      return Math.round(totalDays / this.salesWithCoordinates.length);
    },
    uniqueCities() {
      const cities = new Set();
      this.salesWithCoordinates.forEach((sale) => {
        if (sale.location) {
          cities.add(sale.location);
        }
      });
      return Array.from(cities);
    },
    // Sales count by closing time
    fastSalesCount() {
      return this.salesWithCoordinates.filter(
        (sale) => (sale.timeDiffDays || 0) <= 7,
      ).length;
    },
    moderateSalesCount() {
      return this.salesWithCoordinates.filter((sale) => {
        const days = sale.timeDiffDays || 0;
        return days > 7 && days <= 14;
      }).length;
    },
    slowSalesCount() {
      return this.salesWithCoordinates.filter(
        (sale) => (sale.timeDiffDays || 0) > 14,
      ).length;
    },
    salesWithoutCoverageWithCoordinates() {
      return this.salesDetails.filter(
        (sale) =>
          sale.status === "SIN COBERTURA / NO APLICA" &&
          sale.latitude &&
          sale.longitude &&
          !isNaN(sale.latitude) &&
          !isNaN(sale.longitude) &&
          sale.latitude !== 0 &&
          sale.longitude !== 0,
      );
    },
    salesWithoutCoverageTotal() {
      return this.report.salesWithoutCoverage || 0;
    },
    noCoverageUniqueProvinces() {
      const provinces = new Set();
      this.salesWithoutCoverageWithCoordinates.forEach((sale) => {
        provinces.add(sale.province);
      });
      return Array.from(provinces);
    },
    noCoverageUniqueCities() {
      const cities = new Set();
      this.salesWithoutCoverageWithCoordinates.forEach((sale) => {
        cities.add(sale.location);
      });
      return Array.from(cities);
    },
  },
  watch: {
    cityUserTypeFilter() {
      this.countUsersByCity();
    },
    salesDetails: {
      handler() {
        if (this.salesDetails.length > 0) {
          this.$nextTick(() => {
            // Initialize main map if there are sales with coordinates
            if (this.salesWithCoordinates.length > 0) {
              this.initializeMap();
            }

            // Initialize no coverage map if there are sales without coverage with coordinates
            if (this.salesWithoutCoverageWithCoordinates.length > 0) {
              // Add delay to prevent conflicts
              setTimeout(() => {
                this.initializeNoCoverageMap();
              }, 200);
            }
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.initializeDates();
    this.getAverageDealClosingTime();

    // Delay the initial load slightly to ensure templates are rendered
    setTimeout(() => {
      this.getSummary();
      this.getUsers();
      this.getSales();
      this.fetchTotalBalance();
      this.getSalesWithoutCoverage();
    }, 100);
  },
  beforeUnmount() {
    try {
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
    } catch (error) {
      console.warn("Error removing sales map:", error);
    }

    try {
      if (this.noCoverageMap) {
        this.noCoverageMap.remove();
        this.noCoverageMap = null;
      }
    } catch (error) {
      console.warn("Error removing no coverage map:", error);
    }
  },
};
</script>

<style scoped>
.dateContainer {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.date-input {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  min-width: 150px;
}

@media screen and (max-width: 576px) {
  .dateContainer {
    flex-direction: column;
    align-items: stretch;
  }

  .dateContainer > div:last-child {
    margin-top: 10px;
  }

  .dateContainer button {
    width: 100%;
  }
}

.labelText {
  font-weight: 500;
  color: #333;
}

.title {
  font-weight: bold;
  color: #333;
  font-size: 1.1em;
  margin-bottom: 15px;
}

.text-muted {
  font-size: 0.85em;
}

.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 10px;
}

.stat-item {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.stat-label {
  font-size: 0.9em;
  color: #666;
}

.stat-value {
  font-size: 1.2em;
  font-weight: bold;
  color: #830b83;
}

.stat-detail {
  font-size: 0.75em;
  color: #666;
  font-style: italic;
  margin-top: 2px;
  display: block;
}

.table {
  margin-top: 20px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table th {
  background-color: #f8f9fa;
  color: #333;
  font-weight: 600;
}

.table td {
  vertical-align: middle;
}

.card-data {
  padding: 20px;
  display: flex;
  width: fit-content;
  height: fit-content;
  flex-direction: row !important;
  gap: 10px;
}

.chart-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
}

.chart-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 500px;
}

.stats-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.summary-item {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

.summary-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.summary-label {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 5px;
}

.summary-value {
  font-size: 1.2em;
  font-weight: bold;
  color: #830b83;
}

.ranking-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ranking-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 15px;
}

.ranking-list {
  list-style: none;
  padding: 0;
}

.ranking-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  gap: 6px;
}

.ranking-position {
  font-weight: bold;
}

.ranking-name {
  flex: 1;
}

.ranking-value {
  font-size: 0.9em;
  color: #666;
}

.province-summary-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  border: 1px solid #e9ecef;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.province-summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.provinces-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .provinces-grid {
    grid-template-columns: 1fr;
  }
}

.province-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: box-shadow 0.2s ease;
}

.province-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.province-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
}

.province-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.province-rank {
  background-color: #830b83;
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: bold;
}

.province-name {
  font-size: 1.2em;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.province-count {
  font-size: 1.5em;
  font-weight: bold;
  color: #830b83;
}

.province-details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.province-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-label {
  font-size: 0.8em;
  color: #666;
  margin-bottom: 2px;
}

.stat-value {
  font-size: 1.2em;
  font-weight: bold;
  color: #830b83;
}

.top-cities {
  margin-bottom: 15px;
}

.cities-label {
  color: #666;
  font-weight: 500;
}

.cities-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.city-tag {
  background-color: #f8f9fa;
  color: #495057;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  border: 1px solid #dee2e6;
}

.province-actions {
  text-align: center;
}

.btn-details {
  background-color: #830b83;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 0.85em;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-details:hover {
  background-color: #6a0a6a;
}

.expanded-details {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
}

.all-cities strong {
  color: #333;
  font-size: 0.9em;
}

.cities-grid-simple {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.city-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.city-name {
  font-size: 0.85em;
  color: #333;
}

.city-users {
  font-size: 0.85em;
  font-weight: 600;
  color: #830b83;
}

.no-provinces-found {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.no-provinces-found i {
  font-size: 3em;
  margin-bottom: 20px;
  color: #ccc;
}

.no-provinces-found p {
  margin: 0;
  color: #6c757d;
}

/* Map Styles */
.map-container {
  height: 500px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

#sales-map,
#no-coverage-map {
  height: 500px;
  width: 100%;
  border-radius: 8px;
  z-index: 1;
}

.map-stats {
  margin-bottom: 20px;
}

.map-stat-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;
}

.map-stat-card:hover {
  transform: translateY(-2px);
}

.map-stat-card .stat-number {
  font-size: 1.5em;
  font-weight: bold;
  color: #830b83;
  display: block;
}

.map-stat-card .stat-label {
  font-size: 0.85em;
  color: #666;
  margin-top: 5px;
}

.map-legend {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.legend-title {
  font-size: 1em;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.legend-items {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9em;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.map-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 500px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.popup-content {
  min-width: 200px;
}

.popup-title {
  color: #830b83;
  margin-bottom: 10px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

.popup-details p {
  margin: 5px 0;
  font-size: 0.9em;
}

.popup-details strong {
  color: #333;
}

/* Custom marker styles */
.custom-marker {
  background: transparent !important;
  border: none !important;
}

/* Leaflet popup customization */
.leaflet-popup-content-wrapper {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.leaflet-popup-tip {
  background: white;
}

.cities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

.city-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: box-shadow 0.2s ease;
}

.city-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.city-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.city-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.city-rank {
  background-color: #830b83;
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: bold;
}

.city-name {
  font-size: 1.1em;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.city-count {
  font-size: 1.3em;
  font-weight: bold;
  color: #830b83;
}

.city-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.city-province {
  font-size: 0.9em;
  color: #666;
}

.city-percentage {
  font-size: 0.9em;
  color: #830b83;
  font-weight: 600;
  background-color: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

/* Additional utility classes */
.text-danger {
  color: #dc3545 !important;
}

/* Map popup customization for no coverage */
.map-popup {
  font-family: inherit;
}

.map-popup h6 {
  margin-bottom: 10px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

.map-popup p {
  margin: 5px 0;
  font-size: 0.9em;
}

.map-popup strong {
  color: #333;
}
</style>
